export default {
  default: [
    {
      name: "payments",
      path: "fee",
      component: () => import("./views/FeeView.vue")
    }
  ]
};
